import { PermissionTypes } from '@/constants/permissions'
import { usePermission } from '@/hooks/usePermission'

/**
 * SuperAdmin = platform (Tenants.View). Tenant Admin = customer admin (Users.View, no Tenants.View).
 */
export function useAppRole() {
	const { userHasPermission } = usePermission()
	const isSuperAdmin = userHasPermission(PermissionTypes.Permissions_Tenants_View)
	const isTenantAdmin =
		userHasPermission(PermissionTypes.Permissions_Users_View) && !isSuperAdmin
	const showManageSubscriptionPlansMenu = isSuperAdmin
	const showManagePromoCodesMenu = isSuperAdmin
	const showManageCustomPricingMenu = isSuperAdmin
	const showManageSqlDbdInstallerMenu = isSuperAdmin
	const showBrowsePlansMenu = isTenantAdmin
	const showMyCustomPlanRequests = isTenantAdmin
	const showSalesMenu = isSuperAdmin
	const showMySubscriptions =
		userHasPermission(PermissionTypes.Permissions_MySubscriptions_View) && !isSuperAdmin

	return {
		isSuperAdmin,
		isTenantAdmin,
		showManageSubscriptionPlansMenu,
		showManagePromoCodesMenu,
		showManageCustomPricingMenu,
		showManageSqlDbdInstallerMenu,
		showBrowsePlansMenu,
		showMyCustomPlanRequests,
		showSalesMenu,
		showMySubscriptions,
	}
}
